import { Dropdown } from 'react-bootstrap';
import { useAppDispatch } from '../../../../app/hooks';

import profilePic from '../../../../assets/images/profile-pic.jpg';
import profilePicOne from '../../../../assets/images/profile-pic-prosumer.jpg';

import { logout } from '../../../../slices/auth.slice';
import { AuthUser, selectUser } from '../../../../../src/slices/auth.slice';
import { useAppSelector } from '../../../../app/hooks';
import { ProfileState, selectProfile } from '../../../../slices/profile.slice';

const ProfileNav = () => {

  const dispatch = useAppDispatch();
  //const username = localStorage.getItem("username")
  const auth = JSON.parse(localStorage.getItem('auth')!)
  const handleLogout = () => {
    dispatch(logout());
  }

  let authUser: AuthUser = useAppSelector(selectUser);
  const profilePicImg = authUser.userType === 'Consumer' ? profilePic : profilePicOne;

  const currentProfileInfo: ProfileState = useAppSelector(selectProfile);

  return (
    <div>
      <Dropdown.Item href="/profile" className='py-4 px-4'>
        <div className='profilePic'>
          <img alt='profilePicImg'
            src={currentProfileInfo.imageUrl ? currentProfileInfo.imageUrl : profilePicImg} />
        </div>
        <div className='userDataSummery'>
          <div className='w700 w-100'>
            {auth?.legalName}</div>
          <div className='w-100'>{auth?.emailAddress}</div>
          {/* <div className='w-100'>Asia/Colombo</div> */}
        </div>
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item className='logout' href="" onClick={(e) => handleLogout()}>
        Logout
      </Dropdown.Item>
    </div>
  )
}

export default ProfileNav;